import { Component, OnInit, HostBinding, Input } from '@angular/core';
import { ConditionalTemplateRunner } from '../../service/data';
import { CTMultiSelectSetting } from '../../../element/service/recordview-param';
import { MultiSelectConditionalValue } from '../../model/model';

@Component({
	selector: 'common-ct-runner-multi-select',
	templateUrl: './ct-runner-multi-select.component.html',
	styleUrls: ['./ct-runner-multi-select.component.scss']
})
export class CtRunnerMultiSelectComponent implements OnInit {
	@HostBinding('class.ct-runner-multi-select') hostClass = true;
	@Input() data: ConditionalTemplateRunner;
	get setting(): CTMultiSelectSetting {
		if (this.data) {
			return this.data.Setting as CTMultiSelectSetting;
		}
		return undefined;
	}
	getOptionCheck(val: string): boolean {
		const mval = this.data.Data.Value as MultiSelectConditionalValue;
		if (mval && mval.Value) {
			return mval.Value.indexOf(val) > -1;
		}
		return false;
	}
	setOptionCheck(val: string, check: boolean) {
		let mval = this.data.Data.Value as MultiSelectConditionalValue;
		if (!mval) {
			mval = { Value: [] } as MultiSelectConditionalValue;
			this.data.Data.Value = mval;
		}
		mval.OtherOption = this.setting.OtherOption;
		mval.Options = this.setting.Options.filter(v => v.Value !== this.setting.OtherOption).map(v => v.Value);

		let arr = mval.Value;
		if (!arr) {
			arr = [];
			mval.Value = arr;
		}

		const idx = arr.indexOf(val);
		if (check && idx === -1) {
			arr.push(val);
		}
		if (!check && idx > -1) {
			arr.splice(idx, 1);
		}
		this.data.enable = arr && arr.length > 0;
	}
	constructor() {}

	ngOnInit() {}
}
